import axios from 'axios';
import {
  getToken, getValidSession, logout, setToken,
} from './auth';
import config from '../config';

const api = axios.create({
  baseURL: config.urlApi,
  responseType: 'json',
});

api.interceptors.request.use(async (config) => {
  const token = getToken();

  if (token && config.skipAuthorization !== true) {
    config.headers.Authorization = token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const nextToken = response.headers.authorization;

    if (
      response.config.skipAuthorization !== true
      && nextToken
      && getToken() !== nextToken
    ) {
      setToken(nextToken); // edit new token expire 15 min
    }
    return response.data;
  },
  (error) => {
    let errorObj = null;

    if (typeof error === 'string') {
      errorObj = JSON.parse(JSON.stringify(error));
    } else {
      errorObj = error;
    }

    if (errorObj.hasOwnProperty('CancellationError')) return errorObj;

    const responseConfig = errorObj.response
      ? errorObj.response.config
      : errorObj.config;
    const skipSessionValidation = responseConfig
      && responseConfig.skipSessionValidation === true;

    if (!skipSessionValidation && !getValidSession()) {
      logout();
    }

    if (errorObj.hasOwnProperty('response') && errorObj.response !== undefined) {
      if (errorObj.response.status === 401) {
        // auto logout if 401 response returned from api
        if (errorObj.response.data === 'user.password.invalid') {
          errorObj.response.data = 'Usuário não autorizado, verifique suas credenciais.';
        } else if (errorObj.response.data === 'without.permission') {
          errorObj.response.data = 'Usuário com permissões insuficientes.';
        } else if (errorObj.response.config.url === '/manager/login') {
          errorObj.response.data = 'Falha na autenticação.';
        } else if (!skipSessionValidation) {
          logout();
        }
      }
    }

    return Promise.reject(errorObj.response || errorObj);
  },
);

export default api;
